

export default promiseSequence;
import { Promise } from 'sander';
function promiseSequence(arr, callback) {
	var len = arr.length;
	var results = new Array(len);

	var promise = Promise.resolve();

	function next(i) {
		return promise.then(function () {
			return callback(arr[i], i);
		}).then(function (result) {
			return results[i] = result;
		});
	}

	var i = undefined;

	for (i = 0; i < len; i += 1) {
		promise = next(i);
	}

	return promise.then(function () {
		return results;
	});
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/promiseSequence.js.01-babel.map